import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import NumericInput from '../numericInput/numericInput';
import { dataHooks } from './constants';

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _this.onSlideStart = function (e) {
      window.addEventListener('mousemove', _this.onSlide, true);
      window.addEventListener('mouseup', _this.onSlideEnd, true);
      _this.boundingClientRect = _this.track.getBoundingClientRect();

      if (_.isFunction(_this.props.onSlideStart)) {
        _this.props.onSlideStart(_this.props.value);
      }

      _this.onSlide(e);
    };

    _this.onSlideEnd = function (e) {
      window.removeEventListener('mousemove', _this.onSlide, true);
      window.removeEventListener('mouseup', _this.onSlideEnd, true);

      _this.onSlide(e);

      if (_.isFunction(_this.props.onSlideEnd)) {
        _this.props.onSlideEnd(_this.props.value);
      }
    };

    _this.onSlide = function (e) {
      if (!_this.props.disabled) {
        var _this$props = _this.props,
            step = _this$props.step,
            min = _this$props.min,
            max = _this$props.max;
        var _this$boundingClientR = _this.boundingClientRect,
            left = _this$boundingClientR.left,
            width = _this$boundingClientR.width;
        var precision = 0;

        if (step % 1 !== 0) {
          var stepString = String(step);
          precision = stepString.length - stepString.indexOf('.');
          console.log(precision);
        }

        var rangeRatio = (e.clientX - left) / width;
        var normalizedRangeRation = Math.min(1, Math.max(0, rangeRatio));
        var newValue = min + (max - min) * normalizedRangeRation;
        var mod = newValue % step;
        var diffToNormalize = mod > step / 2 ? mod - step : mod;
        var newValueStepNormalized = newValue - diffToNormalize;

        _this.handleChange(Number(newValueStepNormalized.toFixed(precision)));
      }
    };

    return _this;
  }

  _createClass(Slider, [{
    key: "getKnobLeftInPercent",
    value: function getKnobLeftInPercent() {
      var knobLeftInPercent = (this.props.value - this.props.min) / (this.props.max - this.props.min) * 100;
      return Math.min(100, Math.max(0, knobLeftInPercent)); // normalize value to be between 0 to 100
    }
  }, {
    key: "getFilledPartWidthInPercent",
    value: function getFilledPartWidthInPercent() {
      if (this.props.value < this.props.min) {
        return 0;
      }

      var fillStart = this.props.fillStart === null ? this.props.min : this.props.fillStart;
      var width = Math.abs(this.props.value - fillStart) / (this.props.max - this.props.min) * 100;
      return Math.min(100, Math.max(0, width));
    }
  }, {
    key: "getFilledPartLeftInPercent",
    value: function getFilledPartLeftInPercent() {
      var fillStart = this.props.fillStart === null ? this.props.min : this.props.fillStart;
      var left = (fillStart - this.props.min) / (this.props.max - this.props.min) * 100;
      return Math.min(100, Math.max(0, left));
    }
  }, {
    key: "getColoredPartStyle",
    value: function getColoredPartStyle() {
      var customGradient = this.props.customFillGradient;
      var gradientColor = this.props.disabled ? '#d5d5d5' : this.props.opacityGradientColor;

      if (gradientColor || customGradient) {
        var fillGradient = this.props.disabled || !customGradient ? "linear-gradient(90deg, transparent 0%, ".concat(gradientColor, " 100%)") : customGradient;
        return {
          background: fillGradient,
          width: '100%'
        };
      }

      var fillStart = this.props.fillStart === null ? this.props.min : this.props.fillStart;
      var flip = this.props.value < fillStart ? 180 : 0;
      return {
        transform: "rotateY(".concat(flip, "deg)"),
        left: this.getFilledPartLeftInPercent() + '%',
        width: this.getFilledPartWidthInPercent() + '%'
      };
    }
  }, {
    key: "hasFillStart",
    value: function hasFillStart() {
      return this.props.fillStart !== null && this.props.fillStart !== this.props.min && this.props.fillStart !== this.props.max;
    }
  }, {
    key: "handleChange",
    value: function handleChange(newValue) {
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(newValue);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousemove', this.onSlide, true);
      window.removeEventListener('mouseup', this.onSlideEnd, true);
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(e) {
      e.preventDefault();
    }
  }, {
    key: "getInputProps",
    value: function getInputProps() {
      return _.defaults({
        step: this.props.inputStep || this.props.step,
        min: _.isNumber(this.props.inputMin) ? this.props.inputMin : this.props.min,
        max: _.isNumber(this.props.inputMax) ? this.props.inputMax : this.props.max,
        placeholder: this.props.placeholder || ''
      }, this.props);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          max = _this$props2.max,
          min = _this$props2.min;

      if (value >= min && value <= max) {
        return value;
      }

      return value > max ? max : min;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          automationId = _this$props3.automationId,
          unit = _this$props3.unit,
          disabled = _this$props3.disabled,
          hideNumericInput = _this$props3.hideNumericInput,
          dataHook = _this$props3.dataHook,
          getClassName = _this$props3.getClassName;
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": automationId,
        "data-hook": dataHook,
        "data-disabled": disabled,
        "data-unit": unit,
        "data-min": this.getInputProps().min,
        "data-max": this.getInputProps().max,
        "data-value": this.getValue(),
        className: getClassName('control-slider-input') + (disabled ? ' disabled' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: 'slider' + ' ' + _({
          'with-numeric-input': !hideNumericInput
        }).transform(function (res, value, key) {
          if (value) {
            res.push(key);
          }
        }, []).join(' '),
        onDragStart: this.onDragStart
      }, /*#__PURE__*/React.createElement("span", {
        className: "track",
        onMouseDown: this.onSlideStart,
        "data-hook": dataHooks.sliderTrack,
        ref: function (element) {
          this.track = element;
        }.bind(this)
      }, /*#__PURE__*/React.createElement("span", {
        className: 'colored-part' + ' ' + _({
          'has-fill-start': this.hasFillStart()
        }).transform(function (res, value, key) {
          if (value) {
            res.push(key);
          }
        }, []).join(' '),
        style: this.getColoredPartStyle()
      })), /*#__PURE__*/React.createElement("div", {
        className: "knob-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "knob",
        onMouseDown: this.onSlideStart,
        style: {
          left: this.getKnobLeftInPercent() + '%'
        }
      }))), !hideNumericInput && /*#__PURE__*/React.createElement(NumericInput, _extends({}, this.getInputProps(), {
        dataHook: dataHooks.sliderTextInput
      })));
    }
  }]);

  return Slider;
}(React.Component);

Slider.displayName = 'Slider';
Slider.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Value of the slider */
  value: PropTypes.number,

  /** A callback function triggered when the value changes */
  onChange: PropTypes.func,

  /** Sets the slider to transparent/opaque gradient and specifies its color  */
  opacityGradientColor: PropTypes.string,

  /** Defines a custom gradient color to the slider */
  customFillGradient: PropTypes.string,

  /** Hides the numeric input */
  hideNumericInput: PropTypes.bool,

  /** A callback function triggered when slide starts */
  onSlideStart: PropTypes.func,

  /** A callback function triggered when slide ends */
  onSlideEnd: PropTypes.func,

  /** A callback function triggered when slide is blurred */
  onBlur: PropTypes.func,

  /** Sets the slider disabled */
  disabled: PropTypes.bool,

  /** Sets a minimum number to be displayed in the numeric input */
  inputMin: PropTypes.number,

  /** Sets a maximum number to be displayed in the numeric input */
  inputMax: PropTypes.number,

  /** Sets a minimum number for the slider */
  min: PropTypes.number,

  /** Sets a maximum number for the slider */
  max: PropTypes.number,

  /** Sets a unit to be displayed in the numeric input */
  unit: PropTypes.oneOf(['percent', 'px', 'angle', 'seconds']),

  /** Sets the step size in which the slider increase/decrease */
  step: PropTypes.number,

  /**
   * please use step
   * @deprecated
   */
  inputStep: PropTypes.number,

  /** Sets the point from where the slider looks filled (colored) */
  fillStart: PropTypes.number
};
Slider.defaultProps = {
  value: 0,
  step: 1,
  min: 0,
  max: 100,
  fillStart: null
};
export default compose(Slider);